import React from 'react';
import { ZALO_LINK } from '../constants/links';
import { MIN_ORDER, PHONE_DISPLAY, TEL_LINK, WHOLESALE_POLICIES } from '../constants/site-data';

function WholesaleSection() {
  return (
    <section id="wholesale" className="bg-forest text-white">
      <div className="page-container flex flex-wrap gap-14 py-24">
        <div className="flex min-w-0 flex-[1_1_420px] flex-col gap-5">
          <span className="eyebrow text-gold">Dịch vụ bán sỉ</span>
          <h2 className="section-title">Nhập bánh tráng Đà Lạt cho cửa hàng của bạn.</h2>
          <p className="m-0 text-[17px] text-mist">
            Chúng tôi chuyên cung cấp bánh tráng đặc sản Đà Lạt cho các đại lý, cửa hàng bán lẻ và các đơn vị kinh doanh
            với mức giá ưu đãi. Sản phẩm đảm bảo chất lượng, đóng gói cẩn thận và có tem nhãn đầy đủ.
          </p>
          <div className="flex flex-wrap items-baseline gap-3.5 py-3">
            <span className="font-display text-[clamp(3.5rem,8vw,5rem)] font-extrabold leading-none tracking-[-0.03em] text-gold">
              20–35%
            </span>
            <span className="max-w-[10rem] text-[15px] leading-[1.4] text-mist">chiết khấu tùy số lượng đặt hàng</span>
          </div>
          <div className="flex flex-wrap gap-3">
            <a
              href={ZALO_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-lg bg-gold text-forest hover:bg-white hover:text-forest"
            >
              Nhận báo giá sỉ
            </a>
            <a href={TEL_LINK} className="btn btn-lg border-[1.5px] border-white/35 font-semibold text-white hover:border-white hover:text-white">
              Gọi {PHONE_DISPLAY}
            </a>
          </div>
        </div>

        <div className="flex min-w-0 flex-[1_1_460px] flex-col gap-5">
          <div className="flex flex-col gap-3.5 rounded-3xl border border-white/[0.12] bg-white/[0.06] p-7">
            <h3 className="m-0 font-display text-xl font-bold">Chính sách bán sỉ</h3>
            <ul className="m-0 flex list-none flex-col gap-3 p-0">
              {WHOLESALE_POLICIES.map((policy) => (
                <li key={policy} className="flex items-start gap-3 text-[15px] text-mist-light">
                  <svg aria-hidden="true" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#F5B83D" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" className="mt-0.5 flex-none">
                    <path d="M5 12l5 5 9-10" />
                  </svg>
                  <span>{policy}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-2 rounded-3xl bg-white p-7 text-ink">
            <h3 className="m-0 mb-2 font-display text-xl font-bold">Số lượng đặt hàng tối thiểu</h3>
            <dl className="m-0">
              {MIN_ORDER.map((item) => (
                <div key={item.name} className="flex justify-between gap-4 border-t border-line-soft py-3 text-[15px]">
                  <dt>{item.name}</dt>
                  <dd className="m-0 whitespace-nowrap font-bold">{item.qty}</dd>
                </div>
              ))}
            </dl>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WholesaleSection;
